import React, {Component, PropTypes} from 'react'
import {Row, Col} from 'react-bootstrap'
import cx from 'classnames'
import {control} from'../react/control'
import Icon from './Icon'
import style from './TypeaheadBar.less'

function escapeRegExp(value) {
    return value.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&')
}

export function matcher({source, identify=(v) => v}) {
    return (q, cb) => {
        var matches

        if (q) {
            const regexp = new RegExp(escapeRegExp(q), 'i')
            matches = source.filter((value) => regexp.test(identify(value)))
        } else {
            matches = source
        }

        cb(matches)
    }
}

class TypeaheadBar extends Component {
    static propTypes = {
        size: PropTypes.string,
        split: PropTypes.bool,
        header: PropTypes.object,
        source: PropTypes.func.isRequired,
        display: PropTypes.func,
        identify: PropTypes.func,
        value: PropTypes.array.isRequired,
        onChange: PropTypes.func.isRequired
    }

    static defaultProps = {
        display: (v) => v,
        identify: (v) => v
    }

    constructor(props) {
        super(props)

        this.state = {
            matches: []
        }
    }

    componentWillMount() {
        const {source} = this.props

        source(null, (matches) => {
            this.setState({matches})
        })
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.source != this.props.source) {
            const {source} = nextProps
            const {query} = this.state
            
            source(query, (matches) => {
                this.setState({matches})
            })
        }
    }

    _match(event) {
        const {source} = this.props
        const query = event.target.value || null

        source(query, (matches) => {
            this.setState({query, matches})
        })
    }

    _clear(event) {
        const {source} = this.props
        const query = null

        event.preventDefault()

        source(query, (matches) => {
            this.setState({query, matches})
        })
    }

    _toggle(item) {
        const {identify, value, onChange} = this.props
        const itemId = identify(item)
        const index = value.findIndex((value) => identify(value) == itemId)
        
        var nextValue = [...value]
        if (index >= 0) {
            nextValue.splice(index, 1)
        } else {
            nextValue.push(item)
        }
        onChange(nextValue)
    }

    _isChecked(item) {
        const {identify, value} = this.props
        const itemId = identify(item)

        return value.find((value) => identify(value) == itemId) != null
    }

    render() {
        const {size, split, header, source, display, identify, value, onChange, ...other} = this.props
        const {query, matches} = this.state
        const sizeClass = size && size.toLowerCase()
        const resultLength = size == 'small' && matches.length || 16

        const matchElement = (match) => (
           <li key={identify(match)}>
                <label>
                    <input
                        type='checkbox'
                        checked={this._isChecked(match)}
                        onChange={() => this._toggle(match)} />
                    {display(match)}
                </label>
            </li>
        )

        return (
            <div className={cx(style.default, style[sizeClass], {[style.split]: split})}>
                <div className={style.search}>
                    {query && (
                        <a
                            href=''
                            onClick={(e) => this._clear(e)}>
                            <Icon icon='cross' size={size == 'small' && 'xs' || 'md'} />
                        </a>
                    )}
                    {!query && (
                        <Icon icon='search' size={size == 'small' && 'xs' || 'md'} />
                    )}
                    <div className={style.container}>
                        <input
                            type='text'
                            value={query}
                            onChange={(e) => this._match(e)}
                            {...other} />
                    </div>
                </div>
                {header}
                <div className={style.result}>
                    <Row>
                        <Col sm={split && 6 || 12}>
                            <ul>
                                {matches.slice(0, resultLength / 2 + 1).map(matchElement)}
                            </ul>
                        </Col>
                        <Col sm={split && 6 || 12}>
                            <ul>
                                {matches.slice(resultLength / 2 + 1, resultLength).map(matchElement)}
                            </ul>
                        </Col>
                    </Row>
                </div>
            </div>
        )
    }
}

TypeaheadBar = control({
    value: []
})(TypeaheadBar)

export default TypeaheadBar


// WEBPACK FOOTER //
// ./lib/core/components/TypeaheadBar.js